import { TbReportMoney } from 'react-icons/tb'

import { DictionaryStatusTag } from '@/Containers/TransportationSection/Components'
import { Hint } from '@/Ship/Components/Hint'

import { ClientLossesTable } from '../Components/ClientLossesTable'
import { ReportFrame } from '../Components/ReportFrame'
import { LOST_APPLICATION_STATUS } from '../Contracts/IClientLossesReport'
import { clientLossesReportStore } from '../Stores/ReportStore'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/**
 * «Звіт по програним заявкам» (`SPEC-027` §2.3, §4.4). Адреса змінилась
 * (`/report/client-losses` замість `crm-clients-loss-applications`, К-08).
 */
const ClientLossesPage = () => (
    <ReportFrame
        reportKey="Report.ClientLosses"
        store={clientLossesReportStore}
        hint={
            <Hint id="report.losses.table">
                Заявки, переведені в{' '}
                <DictionaryStatusTag resource={LOST_APPLICATION_STATUS.resource} code={LOST_APPLICATION_STATUS.code} /> у
                вибраному періоді, за причинами. Адміністратор і ролі «Кам», «Фінанси» бачать усіх клієнтів, решта — лише
                тих, де вони серед відповідальних.
            </Hint>
        }
        isEmpty={(report) => report.rows.length === 0}
    >
        {(report) => <ClientLossesTable report={report} />}
    </ReportFrame>
)

export default ClientLossesPage

export const pageConfig: IPageConfig = {
    key: 'Report.ClientLosses',
    route: '/report/client-losses',
    title: 'Звіт по програним заявкам',
    icon: <TbReportMoney />,
}
